export default "__VITE_ASSET__CRUSW1tb__"